import { Input } from '@/components/ui-kit/input';
import { Search } from 'lucide-react';

interface TemplatesSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

/** Debounced-search text input shared by both templates tab toolbars. */
export function TemplatesSearchInput({ value, onChange, placeholder }: TemplatesSearchInputProps) {
  return (
    <div className="relative w-full sm:w-72">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-globe-grey" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="h-9 pl-9"
      />
    </div>
  );
}
